export const BILLING_CYCLE_MONTHLY_ID = 1;
export const BILLING_CYCLE_WEEKLY_ID = 2;
export const BILLING_CYCLE_ANNUAL_ID = 3;
export const BILLING_CYCLE_QUATERLY_ID = 7;
